import {
  Datagrid,
  TextField,
  NumberField,
  Loading,
  FunctionField,
  ListContextProvider,
  useList,
} from 'react-admin';
import { Box } from '@mui/material';
import { AddGroupToMachineButton } from './AddGroupToMachineButton';
import { RemoveGroupFromMachineButton } from './RemoveGroupFromMachineButton';
import { useFetchRecordAssociation, EmptyList } from '../../utils';
import { Group } from '../../types';

export const MachineGroupsList = () => {
  const {
    data: groups,
    loading,
    refresh,
  } = useFetchRecordAssociation<Group>({
    getEndpoint: (id) => `/api/machines/${id}/groups`,
  });

  const listContext = useList({
    data: groups,
    sort: { field: 'id', order: 'ASC' },
  });

  if (loading) return <Loading />;

  if (!groups || groups.length === 0) {
    return (
      <EmptyList
        message="This machine is not associated with any groups."
        action={<AddGroupToMachineButton onSuccess={refresh} />}
      />
    );
  }

  return (
    <>
      <ListContextProvider value={listContext}>
        <Datagrid
          bulkActionButtons={false}
          rowClick={(id) => `/groups/${id}/show`}
          sx={{
            '& .column-id': { textAlign: 'left' },
            '& .column-id th': { textAlign: 'left' },
          }}
        >
          <NumberField source="id" textAlign="left" sortable />
          <TextField source="name" sortable />
          <FunctionField
            render={(group: Group) => (
              <RemoveGroupFromMachineButton
                groupId={group.id}
                groupName={group.name}
                onSuccess={refresh}
              />
            )}
          />
        </Datagrid>
      </ListContextProvider>
      <Box sx={{ mt: 1, mb: 1, textAlign: 'right' }}>
        <AddGroupToMachineButton onSuccess={refresh} />
      </Box>
    </>
  );
};
